import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutComponent implements OnInit {
  pt: string = 'pt-100';
  pb: string = 'pb-70'; 
  ptb: string = 'ptb-100'; 


  constructor() { }

  ngOnInit(): void {
  }

}
